var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTshirtfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_587)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43247 2.69521C6.59391 2.87356 5.8142 3.29764 5.18928 3.92703L0.396781 8.7538C-0.054966 9.20878 -0.0669331 9.96048 0.370081 10.4309L2.70757 12.947C3.16241 13.4366 3.91822 13.4246 4.35861 12.9208L4.8529 12.3554C4.99249 12.1957 5.24713 12.2988 5.24713 12.5151V20.3631C5.24713 21.0172 5.75475 21.5473 6.38094 21.5473H17.719C18.3452 21.5473 18.8528 21.0172 18.8528 20.3631V12.5151C18.8528 12.2988 19.1075 12.1957 19.2471 12.3554L19.7414 12.9208C20.1818 13.4246 20.9376 13.4366 21.3924 12.947L23.7299 10.4309C24.1669 9.96048 24.1549 9.20878 23.7032 8.7538L18.9107 3.92703C18.2858 3.29763 17.506 2.87355 16.6675 2.6952C16.3183 4.93122 14.384 6.64207 12.05 6.64207C9.716 6.64207 7.78161 4.93123 7.43247 2.69521Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1447 2.59998H8.95525C9.24785 4.04138 10.5222 5.12628 12.05 5.12628C13.5777 5.12628 14.8521 4.04138 15.1447 2.59998Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtfill);
export default __webpack_public_path__ + "static/media/tshirt.fill.d8a0c5f8998210cb1543b1a1602b7908.svg";
export { ForwardRef as ReactComponent };